<!--suppress ALL -->

<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản đi (Vai trò đã bị khóa)
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div
                  class="flex-row flex-left__top margin-right-10 custom-label__input"
                  v-bind:style="{ width: '100%', 'justify-content': 'center' }"
                >
                  <span class="label-input">Chọn role: </span>
                  <selector
                    @searchDocCV="searchDocCV"
                    @searchDocVT="searchDocVT"
                  />
                </div>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <infinite-loading ref="infiniteLoading" spinner="spiral">
                    <div slot="spinner">
                      Vui lòng chọn role đã khóa để truy xuất văn bản
                    </div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
    </template>
  </listTemplate>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
import listTemplate from "../../common/list";
import headerTemplate from "../../../components/header/main-header.vue";
import searchTemplate from "../../common/search";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
import DabanhanhAdvanceSearch from "../components/dabanhanh-advance-search";
import Selector from "../../common/locked-role-select-branch.vue";

export default {
  components: {
    Selector,
    BreakWordSpan,
    DabanhanhAdvanceSearch,
    InfiniteLoading,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
    subHeader: () => import("../../../components/main/sub-header.vue"),
    SortCaret: () => import("../SortCaret")
  },

  mixins: [vbAttachmentTokenMixin],

  data() {
    return {
      perfectScrollbarSetting: { maxScrollbarLength: 350 }
    };
  },

  created() {
    this.$store.commit("setUserDeptRoleLocked", null);
  },

  methods: {
    refreshSearch() {
      this.outgoingDocs = [];
      this.page = 0;
      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    searchDocCV() {
      this.$router.replace({
        name: "lockedRoleDocOutCV",
        params: this.$route.params,
      });
      this.refreshSearch();
    },

    searchDocVT() {
      this.$router.replace({
        name: "lockedRoleDocOutVT",
        params: this.$route.params,
      });
      this.refreshSearch();
    }
  }
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/locked-role/lockedRoleDocOutIndex.vue